import React from "react";

const SelectDropdown = ({
  label,
  name,
  errors,
  options,
  register,
  value,
  onChange,
  placeholder,
  disabled,
  className
}) => {

  return (
    <div className={`input-group ${className ? className : ""}`}>
      <label>
        {label}
      </label>
      <select
        className={`px-2 pr-0 popUPSelect ${errors && "border-[#ff4d4f!important]"
          }`}
        name={name}
        onChange={onChange}
        {...(register ? register(name, { required: true }) : {})}
        value={value}
        disabled={disabled}
      >
        <option hidden value={""}>{placeholder}</option>
        {options.map((item, idx) => (
          <option key={idx} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectDropdown;
